import axios from 'axios';

export function downloadFile(endpointUrl, fileName = 'download.xlsx') {
  const token = localStorage.getItem('jwt');

  return axios.get(endpointUrl, {
    headers: {
      Authorization: 'Bearer ' + token
    },
    responseType: 'blob'
  })
  .then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.includes('filename=')) {
      const serverFileName = disposition.split('filename=')[1].split(';')[0].replace(/"/g, '');
      fileName = serverFileName;
    }

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
  .catch(error => {
    console.error('File download failed:', error);
    alert('Failed to download file.');
  });
}
